// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"30cc2c3a","455":"0777dfc8","808":"3b3ef337","977":"a6a60906"}[chunkId] + ".chunk.js";
};